module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - White - DKChocolate_LTGrey.61823f4b.jpg";